import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MentoringAgreementComponent } from './mentoring-agreement.component'

@NgModule({
   declarations: [MentoringAgreementComponent],
   imports: [CommonModule],
})
export class MentoringAgreementModule {}
